import { render, staticRenderFns } from "./listaLibrosEstudiante.vue?vue&type=template&id=1a8aa105"
import script from "./listaLibrosEstudiante.vue?vue&type=script&lang=js"
export * from "./listaLibrosEstudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports